import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { WineIcon, Flower2Icon, MusicIcon, UtensilsIcon, ArrowUpRightIcon } from 'lucide-react';
const features = [{
  num: '01',
  icon: UtensilsIcon,
  title: 'Bespoke Catering',
  description: 'Our executive chef crafts farm-to-table menus tailored to your palate, ensuring a culinary experience as memorable as the day itself.'
}, {
  num: '02',
  icon: Flower2Icon,
  title: 'Floral Artistry',
  description: 'In-house floral designers work with seasonal blooms to create breathtaking installations that perfectly complement our spaces.'
}, {
  num: '03',
  icon: MusicIcon,
  title: 'Live Entertainment',
  description: 'From classical string quartets to high-energy reception bands, we curate the perfect soundtrack for every moment.'
}, {
  num: '04',
  icon: WineIcon,
  title: 'Dedicated Coordination',
  description: 'Your personal event director oversees every detail, allowing you to remain fully present in the joy of your celebration.'
}];
export function Experience() {
  return <section id="experience" className="bg-cream texture-linen py-24 md:py-32 px-6 overflow-hidden" data-id="element-28">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-29">
        <div className="mb-16 md:mb-20 text-center" data-id="element-30">
          <span className="block text-copper text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-31">
            The Copper Crest Experience
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal" data-id="element-32">
            Every Detail, Thoughtfully Crafted
          </h2>
        </div>

        <div className="flex flex-col" data-id="element-33">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group border-b border-copper/15 last:border-b-0 py-10 md:py-14 flex items-center gap-6 md:gap-8 relative cursor-pointer" data-id="element-34">
                {/* Number */}
                <div className="font-serif text-5xl md:text-7xl leading-none text-copper/10 select-none shrink-0 w-12 md:w-20 transition-colors duration-700 group-hover:text-copper/25" data-id="element-35">
                  {feature.num}
                </div>

                {/* Icon + Content */}
                <div className="flex items-start gap-5 md:gap-6 flex-1 min-w-0" data-id="element-36">
                  <div className="shrink-0 bg-white p-3 rounded-full shadow-sm border border-copper/10" data-id="element-37">
                    <Icon className="w-5 h-5 text-copper stroke-[1.5]" data-id="element-38" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-39">
                    <h3 className="font-serif text-2xl md:text-3xl text-charcoal mb-2" data-id="element-40">
                      {feature.title}
                    </h3>
                    <p className="text-muted font-light leading-relaxed text-sm md:text-base" data-id="element-41">
                      {feature.description}
                    </p>
                  </div>
                </div>

                {/* Arrow */}
                <div className="shrink-0 hidden sm:flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full border border-copper/15 text-copper/30 group-hover:text-copper group-hover:border-copper/40 transition-all duration-500" data-id="element-42">
                  <ArrowUpRightIcon className="w-4 h-4 md:w-5 md:h-5 stroke-[1.5] transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-43" />
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}